import React, { Component } from 'react'
import Header from 'components/Header';

import dlAndroid from 'img/home/dl_android.png';
import dlIos from 'img/home/dl_ios.png';
import phone0 from 'img/home/phone_0.png';
import phone1 from 'img/home/phone_1.jpg';
import phone2 from 'img/home/phone_2.jpg';
import phone3 from 'img/home/phone_3.jpg';
import phone4 from 'img/home/phone_4.jpg';
import phonebg from 'img/home/phone_bg.png';

import example1 from 'img/home/1.jpg';
import sound1 from 'mp3/1.mp3';
import example2 from 'img/home/2.jpg';
import sound2 from 'mp3/2.mp3';
import example3 from 'img/home/3.jpg';
import sound3 from 'mp3/3.mp3';
import example4 from 'img/home/4.jpg';
import sound4 from 'mp3/4.mp3';
import example5 from 'img/home/5.jpg';
import sound5 from 'mp3/5.mp3';
import example6 from 'img/home/6.jpg';
import sound6 from 'mp3/6.mp3';

import homeVideo from 'video/home.mp4';

class Home extends Component{
    
    state = {
        audio: false,
        playingSound: false
    };

    render() {
        return(
            <section id="main" className={'home-site'}>
                <Header link={'/'}/>
                <video id="home-video" autoPlay muted loop>
                     <source src={homeVideo} type="video/mp4"/>
                </video>
                <div id="home-container-wrapper">
                    <div id="home-container">
                        <h1 id="home-title">LA SOUNDBOX</h1>
                        <div id="home-text">
                            <div className="home-text-centered">
                                <h3 className="margin">Une soundbox nouvelle génération</h3>
                                <ul className="margin">
                                    <li>Rejouez les meilleurs moments de vos films et séries préférés</li>
                                    <li>Partagez les avec vos amis directement sur les réseaux sociaux !</li>
                                    <li>Ajoutez les en sonneries</li>
                                </ul>
                                <div id="home-stores">
                                    <div id="store-ios">
                                        <a href="https://play.google.com/store/apps/details?id=com.clocknotionstudio.lasoundbox3" target="_blank" rel="noopener noreferrer">
                                            <img src={dlAndroid} alt="share_android" text="Share on Android" />
                                        </a>
                                    </div>
                                    <div id="store-android">
                                        <a href="https://apps.apple.com/fr/app/la-soundbox/id1373715291" target="_blank" rel="noopener noreferrer">
                                            <img src={dlIos} alt="share_ios" text="Share on Ios" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="home-mobile">
                            <img id="phone" alt="phone" text="phone" src={phonebg}/>
                            <div id="home-mobile-slider-container">
                                <div id="home-mobile-slider">
                                    <img id="img1" alt="img1" text="img1" src={phone0}/>
                                    <img id="img2" alt="img2" text="img2" src={phone1}/>
                                    <img id="img3" alt="img3" text="img3" src={phone2}/>
                                    <img id="img4" alt="img4" text="img4" src={phone3}/>
                                    <img id="img5" alt="img5" text="img5" src={phone4}/>
                                    <img id="img6" alt="img6" text="img6" src={phone0}/>
                                </div>
                            </div>
                        </div>
                        <div id="home-socials">
                            <p>Venez voter pour la prochaine soundbox sur <a id="facebook" href="https://www.facebook.com/La-Soundbox-200470310761606/" target="_blank" rel="noopener noreferrer">facebook</a>, <a id="instagram" href="https://www.instagram.com/la_soundbox/" target="_blank" rel="noopener noreferrer">instagram</a> ou <a id="twitter" href="https://twitter.com/La_Soundbox" target="_blank" rel="noopener noreferrer">twitter</a>!</p>
                        </div>
                    </div>
                </div>
                <div id='home-example-wrapper'>
                    <div id='home-example'>
                        <h2 className="margin">Voici une petite selection ce que vous retrouverez sur <b>La Soundbox</b></h2>
                        <div id='app-example' className={this.state.playingSound ? `playing s${this.state.playingSound}` : ''}>
                            <div className={'app-example-tile s1'} onClick={() => this.playSound(sound1, 1)}>
                                <img src={example1} alt={'example1'}></img>
                                <div className={'tile-title'}>J'aime me battre</div>
                            </div>
                            <div className={'app-example-tile s2'} onClick={() => this.playSound(sound2, 2)}>
                                <img src={example2} alt={'example2'}></img>
                                <div className={'tile-title'}>Tout noir</div>
                            </div>
                            <div className={'app-example-tile s3'} onClick={() => this.playSound(sound3, 3)}>
                                <img src={example3} alt={'example3'}></img>
                                <div className={'tile-title'}>Pas de palais</div>
                            </div>
                            <div className={'app-example-tile s4'} onClick={() => this.playSound(sound4, 4)}>
                                <img src={example4} alt={'example4'}></img>
                                <div className={'tile-title'}>Carjacker !</div>
                            </div>
                            <div className={'app-example-tile s5'} onClick={() => this.playSound(sound5, 5)}>
                                <img src={example5} alt={'example5'}></img>
                                <div className={'tile-title'}>Jour, nuit..</div>
                            </div>
                            <div className={'app-example-tile s6'} onClick={() => this.playSound(sound6, 6)}>
                                <img src={example6} alt={'example6'}></img>
                                <div className={'tile-title'}>Quand te ...</div>
                            </div>
                        </div>
                        <p>Cliquez sur une case pour jouer un son</p>
                    </div>
                </div>
            </section>
        )
    }

        playSound = (sound, id) => {
            try {
                if(this.state.audio && !this.state.audio.paused && this.state.playingSound === id) {
                    this.state.audio.pause();
                    this.setState({ playingSound: false });
                } else {
                    if(this.state.audio && !this.state.audio.paused) {
                        this.state.audio.pause();
                    }
                    let audio = new Audio(sound),
                        _ = this;
                    audio.play();
                    audio.onended = function() {
                        _.setState({ playingSound: false })
                    };
                    this.setState({
                        audio: audio,
                        playingSound: id
                    });
                }
            } catch(e) {
                console.log(e);
            };
        }
}

export default Home
